<template>
    <div>
        <h2>Verwaltungsbereich</h2>
        <div class="content_container">
            <Navigation :items="components" @click="updateNavigation" :active="active"></Navigation>
            <div class="content">
                <SettingsTable :item="activeItem"></SettingsTable>
            </div>
        </div>
    </div>
</template>

<script>
import Navigation from "../../components/box/Navigation";
import SettingsTable from "./SettingsTable";
import {RepositoryFactory} from "@/scripts/RepositoryFactory";

const UserRepository = RepositoryFactory.get('users');

export default {
    name: "Settings",
    components: {SettingsTable, Navigation},
    created() {
        if (this.$route.hash !== "") {
            this.active = this.$route.hash.replace("#", "");
        }
        if (this.showUserError === true) {
            this.$store.commit('users/showUserError', {data: false})
        }
    },
    data() {
        return {
            key: 0,
            active: 'groups',
            components: [
                {id: 'groups', name: 'Gruppen'},
                {id: 'users', name: 'Benutzer'},
                {id: 'devices', name: 'Devices'},
                {id: 'brandings', name: 'Transparenz'},
                {id: 'dealTypes', name: 'Deal Types'},
                {id: 'salesoffices', name: 'Verkaufsbüros'},
                {id: 'placements', name: 'Placement'},
                {id: 'formats', name: 'Formate'},
                {id: 'seats', name: 'Seats'},
                {id: 'targetings', name: 'Targetings'},
                {id: 'reportings', name: 'Reportings'},
                {id: 'advertisers', name: 'Advertisers'},
            ],
        }
    },
    async mounted() {
        // eslint-disable-next-line no-undef
        let user = sso.getSsoUser()
        if (this.$store.state.users.currentUser === null && user && !this.$store.state.users.loadingUser) {
            await this.getDMTUserByMail(user.mail);
        }
    },
    computed: {
        showUserError() {
            return this.$store.state.users.showUserError;
        },
        activeItem() {
            return this.components.find(x => x.id === this.active);
        }
    },
    methods: {
        updateNavigation(clicked_item) {
            this.active = clicked_item.id;
        },
        async getDMTUserByMail(mail) {
            this.$store.commit('users/setLoading', true);
            const {data} = await UserRepository.getUserByMail(mail);
            this.$store.commit('users/setCurrentUser', data);
            this.$store.commit('users/setLoading', false);
        },
    }

}
</script>

<style lang="scss" scoped>
.content_container {
    display: flex;
    flex-flow: row;
    height: 100%;

    .content {
        background: #fff;
        padding: 2rem 2.5rem;
        width: 100%;
        min-height: 70%;
    }
}

:deep( .nav_container) {
    padding-top: 20px;
}
</style>